import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const contactSchema = z.object({
  name: z.string().trim().min(1).max(100),
  email: z.string().trim().email().max(255),
  phone: z.string().trim().max(40).optional().default(""),
  subject: z.string().trim().max(120).optional().default(""),
  message: z.string().trim().min(10).max(2000),
});

export type ContactInput = z.infer<typeof contactSchema>;

export const sendContactMessage = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => contactSchema.parse(input))
  .handler(async ({ data }) => {
    const { sendTemplateEmail } = await import("@/lib/email-templates/send-email");
    const id = crypto.randomUUID();

    try {
      await sendTemplateEmail("contact-notification", "paul@paulspensnthings.com", {
        templateData: data,
        idempotencyKey: `contact-notification-${id}`,
        replyTo: data.email,
      });
    } catch (error) {
      console.error("contact notification failed", error);
      return { ok: false as const };
    }

    try {
      await sendTemplateEmail("contact-confirmation", data.email, {
        templateData: { name: data.name, message: data.message },
        idempotencyKey: `contact-confirmation-${id}`,
      });
    } catch (error) {
      // The visitor's copy is a courtesy — Paul already has the message.
      console.error("contact confirmation failed", error);
    }

    return { ok: true as const };
  });
